import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Amplify } from 'aws-amplify';
// import config from './aws-exports'
Amplify.configure({
  "aws_project_region": "us-east-1",
  "aws_cognito_identity_pool_id": "us-east-1:6f56565c-147f-446e-ba7d-b99c763a712d",
  "aws_cognito_region": "us-east-1",
  "aws_user_pools_id": "us-east-1_q52qRt2XA",
  "aws_user_pools_web_client_id": "7a96m9hlu8fft2h9h4duhd5p0m",
  "aws_cloud_logic_custom": [
    {
      "name": "swfServerlessStripe",
      "endpoint": "https://x9fto1b73l.execute-api.us-east-1.amazonaws.com/prod",
      "region": "us-east-1"
    }
  ],
  "oauth": {},
  "aws_cognito_username_attributes": [],
  "aws_cognito_social_providers": [],
  "aws_cognito_signup_attributes": [
    "EMAIL"
  ],
  "aws_cognito_mfa_configuration": "OFF",
  "aws_cognito_mfa_types": [
    "SMS"
  ],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": []
  },
  "aws_cognito_verification_mechanisms": [
    "EMAIL"
  ],
  "aws_user_files_s3_bucket": "storieswefeel",
  "aws_user_files_s3_bucket_region": "us-east-1"
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
